import { Percent, Wallet, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: Percent, text: "No transaction fees, ever" },
  { icon: Wallet, text: "Payments go straight to your account" },
  { icon: BadgeCheck, text: "Official Instagram integration" },
];

export default function TrustStrip({ className = "" }) {
  return (
    <ul
      data-testid="plans-trust-strip"
      className={`flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-ink/65 ${className}`}
    >
      {ITEMS.map(({ icon: Icon, text }) => (
        <li key={text} className="inline-flex items-center gap-1.5">
          <Icon size={14} strokeWidth={2.25} className="flex-none text-hotpink" />
          {text}
        </li>
      ))}
    </ul>
  );
}